import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';
import type { Reservation } from '@/api/reservations';

type Variables = {
  startDate: string;
  endDate: string;
  carId: number;
};
export type CreateCalendarBlockResponse = {
  data: Reservation;
};

export const useCreateCalendarBlock = createMutation<
  CreateCalendarBlockResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/internal/partners/reservations/calendar-block',
      method: 'POST',
      data: {
        start_date: variables.startDate,
        end_date: variables.endDate,
        car_id: variables.carId,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
